module.exports = __webpack_public_path__ + "static/media/no-data.061198f3.svg";